const messageStyles = {
  '.message--holder': { height: '32px' },
  '.message--error': { color: 'var(--c-negative)' },
  '.message--success': { color: 'var(--c-success)' },
};

export default messageStyles;
